module.exports = __webpack_public_path__ + "img/s-resize.png?aebf0e93cb84a8b1f96c86d38f037005";